export default {
    ExpenseInvest: 1,  // theo dự án
    ExpenseInvestTask: 2  // theo nhiệm vụ
}